import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useCriteoTracker } from './useCriteoTracker';
import { useDigitalCamp } from './useDigitalCamp';
import { getTransactionId } from './util';

/**
 * 마케팅 트래커 통합 훅 (Facade Pattern)
 * - DigitalCamp, Criteo 트래커를 하나의 인터페이스로 통합
 * - 각 트래커가 실패해도 나머지는 계속 진행
 */
export const useMarketingTracker = () => {
  const $ = _c(17);
  const {
    initScript: initDigitalCamp,
    trackEvent: trackDigitalCamp
  } = useDigitalCamp();
  const {
    initScript: initCriteo,
    trackTransaction: trackCriteoTransaction
  } = useCriteoTracker();
  let t0;
  if ($[0] !== initCriteo || $[1] !== initDigitalCamp) {
    t0 = () => {
      ;
      try {
        initDigitalCamp();
      } catch (t1) {
        const e = t1;
        console.warn("[MarketingTracker] DigitalCamp init failed:", e);
      }
      ;
      try {
        initCriteo();
      } catch (t2) {
        const e_0 = t2;
        console.warn("[MarketingTracker] Criteo init failed:", e_0);
      }
    };
    $[0] = initCriteo;
    $[1] = initDigitalCamp;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const initAll = t0;
  let t1;
  if ($[3] !== trackCriteoTransaction || $[4] !== trackDigitalCamp) {
    t1 = userIdx => {
      const transactionId = getTransactionId("join");
      ;
      try {
        trackDigitalCamp({
          eventName: "join",
          userIdx,
          transactionId
        });
      } catch (t2) {
        const e_1 = t2;
        console.warn("[MarketingTracker] DigitalCamp trackSignup failed:", e_1);
      }
      ;
      try {
        trackCriteoTransaction(transactionId);
      } catch (t3) {
        const e_2 = t3;
        console.warn("[MarketingTracker] Criteo trackSignup failed:", e_2);
      }
    };
    $[3] = trackCriteoTransaction;
    $[4] = trackDigitalCamp;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const trackSignup = t1;
  let t2;
  if ($[6] !== trackCriteoTransaction || $[7] !== trackDigitalCamp) {
    t2 = userIdx_0 => {
      const transactionId_0 = getTransactionId("adultcert");
      ;
      try {
        trackDigitalCamp({
          eventName: "adult_auth",
          userIdx: userIdx_0,
          transactionId: transactionId_0
        });
      } catch (t3) {
        const e_3 = t3;
        console.warn("[MarketingTracker] DigitalCamp trackAdultCert failed:", e_3);
      }
      ;
      try {
        trackCriteoTransaction(transactionId_0);
      } catch (t4) {
        const e_4 = t4;
        console.warn("[MarketingTracker] Criteo trackAdultCert failed:", e_4);
      }
    };
    $[6] = trackCriteoTransaction;
    $[7] = trackDigitalCamp;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const trackAdultCert = t2;
  let t3;
  if ($[9] !== trackCriteoTransaction || $[10] !== trackDigitalCamp) {
    t3 = userIdx_1 => {
      const transactionId_1 = getTransactionId("purchase");
      ;
      try {
        trackDigitalCamp({
          eventName: "purchase",
          userIdx: userIdx_1,
          transactionId: transactionId_1
        });
      } catch (t4) {
        const e_5 = t4;
        console.warn("[MarketingTracker] DigitalCamp trackPurchase failed:", e_5);
      }
      ;
      try {
        trackCriteoTransaction(transactionId_1);
      } catch (t5) {
        const e_6 = t5;
        console.warn("[MarketingTracker] Criteo trackPurchase failed:", e_6);
      }
    };
    $[9] = trackCriteoTransaction;
    $[10] = trackDigitalCamp;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const trackPurchase = t3;
  let t4;
  if ($[12] !== initAll || $[13] !== trackAdultCert || $[14] !== trackPurchase || $[15] !== trackSignup) {
    t4 = {
      initAll,
      trackSignup,
      trackAdultCert,
      trackPurchase
    };
    $[12] = initAll;
    $[13] = trackAdultCert;
    $[14] = trackPurchase;
    $[15] = trackSignup;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};